import { RegistrationExpert } from './ExpertRegistrationForm';

export default RegistrationExpert;
